import React from "react";

import { BorderBoxProps } from "./BorderBoxTypes";
import useBorderBoxStyle from "./useBorderBoxStyle";

const BorderBox: React.FC<BorderBoxProps> = props => {
  const styles = useBorderBoxStyle(props);
  const children = props.labelledById
    ? React.Children.map(props.children, c =>
        React.cloneElement(c as React.ReactElement<{ labelledById: string }>, {
          labelledById: props.labelledById
        })
      )
    : props.children;
  return (
    <div className={styles.borderBox}>
      {props.highlightLeftEdge && <div className={styles.highlight} />}
      {children}
    </div>
  );
};

export default BorderBox;
